import styles from './SpyLaunchSettingsButton.module.css'
import { Calendar2Icon } from 'shared/icons/Calendar2Icon'
import classNames from 'classnames'
import { CustomParams, SlidingParams, SpyLaunchSettings } from 'shared/types/SpyLaunchSettings'
import { DateTime } from 'luxon'
import { useMemo } from 'react'
import { spyLaunchSettingsToString } from 'shared/lib/spyLaunchSettingsToString'



interface SpyLaunchSettingsButtonProps {
    active: boolean
    className?: string
    value?: SpyLaunchSettings
    onClick?: (event: any) => void
}

export const SpyLaunchSettingsButton = (props: SpyLaunchSettingsButtonProps): JSX.Element => {
    const {
        active = false,
        className,
        value,
        onClick
    } = props

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    const hasValue = value!== undefined
    const heading = useMemo(() => {
        if (hasValue){
            return `Date`
        }

        return 'Select Date'
    }, [
        value
    ])

    const spyLaunchSettingsButtonClasses = classNames(styles.SpyLaunchSettingsButton, className, {
        [styles[`SpyLaunchSettingsButton--Active`]]: active,
        [styles[`SpyLaunchSettingsButton--HasValue`]]: hasValue
    })

    const renderValue = (): JSX.Element => {
        if (value === undefined){
            return (
                <></>
            )
        }

        const valueString = spyLaunchSettingsToString(value)

        return (
            <span className={styles.SpyLaunchSettingsButton__ValueContainer}>
                <span className={styles.SpyLaunchSettingsButton__ValueCaption}>
                    {valueString}
                </span>
            </span>
        )
    }

    return (
        <button
            className={spyLaunchSettingsButtonClasses}
            onClick={handleButtonClick}
        >
            <span className={styles.SpyLaunchSettingsButton__HelperContainer}>
                <span className={styles.SpyLaunchSettingsButton__IconContainer}>
                    <Calendar2Icon className={styles.SpyLaunchSettingsButton__Icon} />
                </span>
                <span className={styles.SpyLaunchSettingsButton__Caption}>
                    {heading}
                </span>               
            </span>
            {
                renderValue()
            }
        </button>
    )
}